<template>
     <div id="order-detail">

        <van-nav-bar
            title="休假申请列表菜单"
            left-text="返回"
            left-arrow
            placeholder
            fixed
            @click-left="onClickLeft"
        />
        <div v-if="content != null && content != undefined && content != ''">
            <van-notice-bar
            left-icon="volume-o"
            :text="content"
        />
        </div>

        <!-- <van-cell-group style="margin-top:2px; display: flex;flex-direction: column;text-align: left;padding-left: 15px;word-break: break-all;word-wrap: break-word;">
            <div>调休·年假·干部社员12天带薪病事假(5天以下):事假(1天以下)</div>
        </van-cell-group> -->

        <van-cell-group style="margin-top: 20px;">
            <van-cell title="说明（一）" value="" />
        </van-cell-group>
        <van-notice-bar
            wrapable
            color="#1989fa"
            background="#ecf9ff"
            style="text-align: left"
            :scrollable="false"
            mode="link"
            @click="onSelect(1)"
            text="调休·年假·干部社员12天带薪病事假(5天以下):事假(1天以下)"
        />

        <van-cell-group style="margin-top: 35px;">
            <van-cell title="说明（二）" value="" />
        </van-cell-group>
        <van-notice-bar
            wrapable
            color="#1989fa"
            background="#ecf9ff"
            style="text-align: left"
            :scrollable="false"
            mode="link"
            @click="onSelect(2)"
            text="调休·年假·干部社员12天带薪病事假(5天以上):事假(1天以上)"
        />

        <van-cell-group style="margin-top: 35px;">
            <van-cell title="说明（三）" value="" />
        </van-cell-group>
        <van-notice-bar
            wrapable
            color="#1989fa"
            background="#ecf9ff"
            style="text-align: left"
            :scrollable="false"
            mode="link"
            @click="onSelect(3)"
            text="事假(年度累计12天以上)"
        />


        <van-cell-group style="margin-top: 35px;">
            <van-cell title="说明（四）" value="" />
        </van-cell-group>
        <van-notice-bar
            wrapable
            color="#1989fa"
            background="#ecf9ff"
            style="text-align: left"
            :scrollable="false"
            mode="link"
            v-model="fieldValue"
            @click="onSelect(4)"
            text="可申请病假、婚丧假、产假等休需提交相关证明文件"
        />
        <van-popup v-model="show" round position="bottom">
        <van-cascader
            v-model="cascaderValue"
            title="请选择休假类别"
            :options="options"
            @close="show = false"
            :field-names="fieldNames"
            @finish="onFinish"
        />
        </van-popup>
    </div>
</template>

<script>

    import { Cell, CellGroup, Icon } from 'vant';
    import { Divider } from 'vant';
    import { NavBar } from 'vant';
    import { Dialog } from 'vant';
    import { NoticeBar } from 'vant';
    import { ContactCard } from 'vant';
    import { Card } from 'vant';
    import { Grid, GridItem } from 'vant';
    import { Cascader } from 'vant';
    import Vue from 'vue';
    import {getLevelAll,getLevelId} from '@/api/Classify';
    import {getContent} from "@/api/SystemMessage";
    Vue.use(Cell);
    Vue.use(CellGroup);
    Vue.use(NavBar);
    Vue.use(Icon);
    Vue.use(Divider);
    Vue.use(Dialog);
    Vue.use(NoticeBar)
    Vue.use(ContactCard);
    Vue.use(Grid);
    Vue.use(GridItem);
    Vue.use(Card);
    Vue.use(Cascader);

    export default {
        name: "userApplyDetail",

        data() {
            return {
                id: this.$route.query.orderId,
                show: false,
                fieldValue: '',
                cascaderValue: '',
                // 选项列表，children 代表子选项，支持多级嵌套
                options: [],
                content:'',
                fieldNames: {
                    text: 'name',
                    value: 'seqId',
                    children: 'list',
                },
                orderInfo: {
                    applyNo: '',
                    companyNo: '',
                    username: '',
                    account: '',
                    category: '',
                    classify: '',
                    categoryStr: '',
                    classifyStr: '',
                    reason: '',
                    createTime: '',
                    modifyTime: '',
                    applyStatus: '',
                    errorMsg: '',
                    startTime: '',
                    endTime: ''
                },
                title: '提示',
                messageVisible: false,
                message: "",
                reason: '',
                isShow: true
            }
        },
        created() {
            this.selectContent();
        },
        methods: {
            selectContent(){
                getContent(3)
                    .then((response) => {
                       this.content =  response.data.content;
                    })
            },
            goToBack() {
                this.$router.go(-1);
            },
            onClickLeft() {
                this.$router.go(-1);
            },
            updateApply(){
                var sId = this.id;
                this.$router.push({path: '/updateUserApply', query: {sId}})
            },
            goBack(){
                this.$router.push({path: '/order'});
            },
            showMenu(obj) {
                if (obj == 1) {
                    this.$router.push({path: '/addUserApply'})
                }
                if (obj == 2) {
                    this.$router.push({path: '/addUserApply'})
                }
                if (obj == 3) {
                    this.$router.push({path: '/addUserApply'})
                }
                if (obj == 4) {
                    this.$router.push({path: '/addUserApply'})
                }
            },
            updateCancel() {
                Dialog.confirm({
                    title: '提示',
                    theme: 'round-button',
                    confirmButtonColor: '#1989fa',
                    // cancelButtonColor: '#C8C9CC',
                    cancelButtonColor: '#969799',
                    message: '你确定要执行此操作的吗？',
                })
                .then(() => {
                    // on confirm
                    // this.$router.push({path: '/addUserApply'})
                })
                .catch(() => {
                    // on cancel
                });
            },
            onSelect(type){
                this.options = [];
                getLevelAll(type).then((response) => {
                             this.options = response.data; 
                             })
                this.show = true; 
            },
            // 全部选项选择完毕后，会触发 finish 事件
            onFinish({ selectedOptions }) {
                let seq = '';
                if(selectedOptions.length == 1){
                    seq = selectedOptions[0].seqId;//当前选择的ID
                }
                if(selectedOptions.length == 2){
                    seq = selectedOptions[1].seqId;//当前选择的ID
                }
                Dialog.confirm({
                    title: '提示',
                    theme: 'round-button',
                    confirmButtonColor: '#1989fa',
                    // cancelButtonColor: '#C8C9CC',
                    cancelButtonColor: '#969799',
                    message: '你确定要选择此条目的吗？',
                })
                .then(() => {//确认后触发的方法
                    this.show = false;
                    this.fieldValue = selectedOptions.map((option) => option.text).join('/');
                    getLevelId(seq).then((response) => {
                        let levelOneId = "";
                        let levelTwoId = "";
                        if(response.data.levelType == 2){
                            levelOneId = response.data.parentId;
                            levelTwoId = response.data.seqId;
                        }
                        if(response.data.levelType == 1){
                            levelOneId = response.data.seqId;
                        }
                        this.$router.push({path: response.data.url , query: {levelOneId,levelTwoId}})
                        })
                })
                .catch(() => {
                    // on cancel
                });
            },
            formatStatus(value) {
                if (value === 1){
                    value = '申请中'
                }
                if (value === 2){
                    value = '申请通过'
                }
                if (value === 3){
                    value = '申请异常'
                }
                if (value === 4){
                    value = '用户取消'
                }
                if (value === 6){
                    value = '审批中'
                }
				if (value === 5){
                    value = '审批拒绝'
                }
                return value;
            }
        }
    }
</script>

<style scoped lang="scss">

    .intro-text {
        word-break: break-all;
        word-wrap: break-word;
    }
    .van-cell__title{   
         /* sass 修改子组件样式  /deep/ 或者 >>> */
        text-align: left;
    }


</style>